import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import {
  MatSelectChange,
} from '@angular/material/select';

@Component({
  selector: 'nym-issuance-listing-header',
  templateUrl: './issuance-listing-header.component.html',
  styleUrls: ['./issuance-listing-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IssuanceListingHeaderComponent implements OnInit {

  @HostBinding('class.nym-issuance-listing-header')
  protected get classes(): boolean { return true; }

  @Output()
  protected create: EventEmitter<string> = new EventEmitter();

  @Input()
  public title: string;

  @Input()
  public description: string;

  @Input()
  public types: string[];

  public selected: string[];

  constructor() { }

  public ngOnInit(): void { }

  protected create$$(type: string): void {
    this.create.emit(type);
  }

}
